
<form class="form-wrapper" [formGroup]="filterForm" autocomplete=off>
  <mat-form-field appearance="outline" color="accent">
    <mat-label>{{ 'pages.mitarbeiterverwaltung.filter.suche' | translate }}</mat-label>
    <input
      matInput
      class="suchFeld"
      formControlName="search"
      autocomplete=off
      placeholder="Name Eingeben"
      (input)="search()"
    />
  </mat-form-field>
  <mat-checkbox
    (change)="search()"
    formControlName="deleted"
  >
    {{ 'pages.mitarbeiterverwaltung.filter.deletedUsers' | translate }}
  </mat-checkbox>
</form>
